import { render, staticRenderFns } from "./OrderStoreReview.vue?vue&type=template&id=4a7e49da&scoped=true"
import script from "./OrderStoreReview.vue?vue&type=script&lang=js"
export * from "./OrderStoreReview.vue?vue&type=script&lang=js"
import style0 from "./OrderStoreReview.vue?vue&type=style&index=0&id=4a7e49da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7e49da",
  null
  
)

export default component.exports